import { Tick } from '@assets/index'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import { ContentClassificationData } from '@interfaces/index'
import { onEnterKeyPressAndClick } from '@utils/helpers'
import classNames from 'classnames'
import './ContentButton.scss'
import React, { useCallback } from 'react'

interface ContentButtonProps {
  data: ContentClassificationData
  setChooseContent: (ageRating: string) => void
  chooseContent?: string | number | null
}

export const ContentButton = ({ data, chooseContent, setChooseContent }: ContentButtonProps) => {
  const handleClick = useCallback(
    (e: React.KeyboardEvent | React.MouseEvent) => {
      e.preventDefault()

      onEnterKeyPressAndClick(e, async () => {
        setChooseContent(data.ageRating)
      })
    },
    [data.ageRating, setChooseContent],
  )

  return (
    <div
      id={data.ageRating.toString()}
      className={classNames('list-button', 'focusable', data.ageRating === chooseContent && 'active')}
      tabIndex={-1}
      onKeyDown={handleClick}
      onClick={handleClick}
      key={data.ageRating}
    >
      <div className="tick-icon">{data.ageRating === chooseContent && <Tick />}</div>
      <div className="info">
        <Text tag={TextTag.H1}>{data.ageRating}</Text>
        <Text tag={TextTag.P} className={`innerText `}>
          <Text tag={TextTag.SPAN} className="language">
            {data.label}
          </Text>
        </Text>
      </div>
    </div>
  )
}

export default ContentButton
